import { render } from "./MarketingSiteProxy.vue?vue&type=template&id=1c96c378"
import script from "./MarketingSiteProxy.vue?vue&type=script&lang=js"
export * from "./MarketingSiteProxy.vue?vue&type=script&lang=js"

import "./MarketingSiteProxy.vue?vue&type=style&index=0&id=1c96c378&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__